// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons';
import BookitupAlert from '../../../Atoms/BookitupAlert';

const WorkflowDepricationAlert = () => (
  <BookitupAlert icon={<IconAlertTriangle size={16} />} title="Diese Einstellungen sind veraltet" mb="sm">
    <Text>
      Die Einstellungen in diesem Bereich sind veraltet. Alle Workflows können nun in Workflow-Vorlagen eingestellt
      werden.
    </Text>
  </BookitupAlert>
);

export default WorkflowDepricationAlert;
